/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const customerManagementEventPageOutputItemsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const customerManagementEventPageOutputItemsItemActorRefOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const customerManagementEventPageOutputItemsItemTargetRefRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const customerManagementEventPageOutputItemsItemOccurredAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const customerManagementEventPageOutputItemsItemCorrelationIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const customerManagementEventPageOutputItemsItemSafeChangesOneThreeRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const customerManagementEventPageOutputNextCursorOneMax = 512;

export const customerManagementEventPageOutputNextCursorOneRegExp = new RegExp('^[A-Za-z0-9_-]+$');

export const CustomerManagementEventPageOutput = zod.object({
  items: zod.array(
    zod.object({
      id: zod.uuid().regex(customerManagementEventPageOutputItemsItemIdRegExp),
      actorKind: zod.enum(['user', 'system', 'unknown']),
      actorRef: zod.union([
        zod.uuid().regex(customerManagementEventPageOutputItemsItemActorRefOneRegExp),
        zod.null(),
      ]),
      action: zod.enum([
        'customers.customer-created',
        'customers.customer-renamed',
        'customers.customer-archived',
        'customers.customer-reactivated',
        'customers.customer-deleted',
        'customers.assignment-added',
        'customers.assignment-removed',
        'customers.phone-number-added',
        'customers.phone-number-changed',
        'customers.phone-number-removed',
        'customers.customer-change-refused',
        'customers.assignment-change-refused',
        'customers.phone-number-change-refused',
        'customers.dependency-unavailable',
      ]),
      targetKind: zod.enum(['customer', 'customer-assignment', 'customer-number']),
      targetRef: zod.uuid().regex(customerManagementEventPageOutputItemsItemTargetRefRegExp),
      occurredAt: zod.iso
        .datetime({ offset: true })
        .regex(customerManagementEventPageOutputItemsItemOccurredAtRegExp),
      outcome: zod.enum(['success', 'refused', 'unavailable']),
      reasonCode: zod.union([
        zod.enum([
          'INVALID_REQUEST',
          'VERSION_CONFLICT',
          'CUSTOMER_DELETE_BLOCKED',
          'DEPENDENCY_UNAVAILABLE',
          'CUSTOMER_AUDIT_POLICY_UNAVAILABLE',
          'NOT_FOUND',
          'CUSTOMER_ASSIGNMENTS_BLOCK_ARCHIVE',
          'CUSTOMER_ARCHIVED',
          'IDEMPOTENCY_CONFLICT',
          'CUSTOMER_NAME_EXISTS',
          'CLIENT_CODE_EXHAUSTED',
          'ASSIGNMENT_EXISTS',
          'TEAM_INACTIVE',
          'KNOWN_NUMBER_EXISTS',
        ]),
        zod.null(),
      ]),
      correlationId: zod
        .uuid()
        .regex(customerManagementEventPageOutputItemsItemCorrelationIdRegExp),
      safeChanges: zod.union([
        zod.record(
          zod.string(),
          zod.union([
            zod.boolean(),
            zod.number(),
            zod.uuid().regex(customerManagementEventPageOutputItemsItemSafeChangesOneThreeRegExp),
          ]),
        ),
        zod.null(),
      ]),
    }),
  ),
  nextCursor: zod.union([
    zod
      .string()
      .min(1)
      .max(customerManagementEventPageOutputNextCursorOneMax)
      .regex(customerManagementEventPageOutputNextCursorOneRegExp),
    zod.null(),
  ]),
});

export type CustomerManagementEventPageOutput = zod.input<typeof CustomerManagementEventPageOutput>;
export type CustomerManagementEventPageOutputOutput = zod.output<
  typeof CustomerManagementEventPageOutput
>;
